export default {
  FILTER_STUDY_PLAN_LIST: 'FilterStudyPlanList',
  SORT_STUDY_PLAN_LIST: 'SortStudyPlanList',
  LOAD_STUDY_PLAN_LIST_START: 'LoadStudyPlanListStart',
  LOAD_STUDY_PLAN_LIST_END: 'LoadStudyPlanListEnd',
  SEARCH_STUDY_PLAN_LIST_FILTER_STUDY_PROGRAM_START: 'SearchStudyPlanListFilterStudyProgramStart',
  SEARCH_STUDY_PLAN_LIST_FILTER_STUDY_PROGRAM_END: 'SearchStudyPlanListFilterStudyProgramEnd'
};